// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/systemRouter/systemRouter.js#1 $
'use strict';
angular.module('tcApp')
.factory('SystemRouter', function($http, $q) {
	var routerUrl = 'system.Router.cls';

	var processWorkflow = function(workflowId) {
		var promise = $q(function(resolve, reject) {
			if ((angular.isUndefined(workflowId)) || (workflowId == '')) {
				reject(Error());
			}
			var requestParams = {
				TWKFLI: 0,
				TWKFL: workflowId,
			};

			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};

	var fetchSessionData = function() {
		var menuUrl = routerUrl + '?TSESSION';
		var promise = $q(function(resolve, reject) {
			$http.post(menuUrl)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};
	
	var checkSession = function(componentName, params,
								locksToRestoreClassNames, locksToRestoreIds, locksToRestoreComponentNames) {
		params = angular.copy(params);
		var url = (routerUrl + '?TCACHEDDATA=1');
		if (angular.isDefined(componentName)) {
			url += ('&TCOMPONENT=' + componentName);
		}
		if (angular.isArray(locksToRestoreClassNames) && angular.isArray(locksToRestoreIds)
			&& (locksToRestoreClassNames.length > 0) && (locksToRestoreIds.length > 0)) {
			params['TRESTORELOCKCLASSNAMES'] = locksToRestoreClassNames;
			params['TRESTORELOCKIDS'] = locksToRestoreIds;
			params['TRESTORELOCKCOMPONENTNAMES'] = locksToRestoreComponentNames;
		}
		var promise = $q(function(resolve, reject) {
			$http.post(url, params)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};
	
	var extendSession = function(params) {
		var url = (routerUrl + '?TEXTENDSESSION=1');
		var promise = $q(function(resolve, reject) {
			$http.post(url, params)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};

	var runMenuMethod = function(menuId, passParameters) {
		var url = routerUrl + '?TMENU=' + menuId;
		if (angular.isDefined(passParameters)) {
			url = url + '&' + passParameters;
		}
		return $http.post(url);
	};

	// Accepts parameters as either a serialized string or object
	var fetchComponentData = function(componentName, parameters, componentUniqueIndex, componentUniqueIndexPrefix) {
		var promise = $q(function(resolve, reject) {
			if (angular.isUndefined(parameters)) {
				parameters = {};
			} else if (angular.isString(parameters)) {
				parameters = urlToObject(parameters);
			}
			var componentUrl = (routerUrl + '?TCOMPONENT=' + componentName);
			if (angular.isDefined(componentUniqueIndex)) {
				componentUrl += ('&TCOMPUNIQUEINDEX=' + componentUniqueIndex);
			}
			if (angular.isDefined(componentUniqueIndexPrefix)) {
				componentUrl += ('&TCOMPUNIQUEINDEXPREFIX=' + componentUniqueIndexPrefix);
			}
			
			$http.post(componentUrl, parameters)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};

	var fetchChartData = function(chartBookId, chartId, chartItemId, parameters) {
		var promise = $q(function(resolve, reject) {
			if (angular.isUndefined(chartBookId)) chartBookId = '';
			if (angular.isUndefined(chartId)) chartId = '';
			if (angular.isUndefined(chartItemId)) chartItemId = '';
			if ((chartBookId === '') && (chartId === '')) {
				reject(Error());
				return;
			}
			
			var chartUrl = routerUrl + '?TCHARTBOOK=' + chartBookId + '&TCHART=' + chartId + '&TCHARTITEM=' + chartItemId;
			$http.post(chartUrl, parameters)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};
	
	var fetchChartHasData = function(chartBookId, chartId, parameters) {
		var promise = $q(function(resolve, reject) {
			if (angular.isUndefined(chartBookId)) chartBookId = '';
			if (angular.isUndefined(chartId)) chartId = '';
			if ((chartBookId === '') && (chartId === '')) {
				return;
			}
			
			var componentUrl = routerUrl + '?TDATAONLYCALL=1&TCHARTBOOK=' + chartBookId + '&TCHART=' 
				+ chartId + '&TREQUESTTYPE=hasData';
			$http.post(componentUrl, parameters, {ignoreLoadingBar: true})
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};

	var fetchChartItemData = function(chartId, chartItemId, hasDataOnly, listComponentUniqueIndex, parameters) {
		var promise = $q(function(resolve, reject) {
			if (angular.isUndefined(chartItemId)) chartItemId = '';
			if (angular.isUndefined(chartId)) chartId = '';
			if ((chartItemId === '') && (chartId === '')) {
				return;
			}
			if (angular.isUndefined(listComponentUniqueIndex)) listComponentUniqueIndex = '';
			
			var componentUrl = routerUrl + '?TDATAONLYCALL=1&TCHARTITEM=' + chartItemId + '&TCHART=' 
				+ chartId + '&TREQUESTTYPE=itemData';
			if (hasDataOnly) componentUrl += '&THASDATA=1';
			if (listComponentUniqueIndex != '') {
				componentUrl += ('&TCOMPUNIQUEINDEX=' + listComponentUniqueIndex);
			}
			$http.post(componentUrl, parameters, {ignoreLoadingBar: true})
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};

	var fetchLayoutTranslations = function(contextId) {
		var requestParams = {
			TLAYOUTCONTEXT: contextId
		};
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
				.then(function(data) {
					resolve(data);
				}, function(data) {
					reject(data);
				});
		});
		return promise;
	};

	var saveLayout = function(modelClassName, modelJson) {
		var requestParams = {
			TLAYOUTSAVE: 1,
			TMODELCLASSNAME: modelClassName,
			TLAYOUTJSON: modelJson,
		};
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var importLayout = function(componentName, modelClassName, importContext, questionnaireId) {
		var requestParams = {
			TLAYOUTIMPORT: 1,
			TCOMPONENT: componentName,
			TMODELCLASSNAME: modelClassName,
			TIMPORTCONTEXT: importContext,
			TQUESTIONNAIRE: questionnaireId
		};
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};

	var sourceControlAction = function(action, modelClassName, modelJson) {
		var requestParams = {
			TLAYOUTSCACTION: action,
			TMODELCLASSNAME: modelClassName,
		};
		if (angular.isDefined(modelJson)) {
			angular.extend(requestParams, {TLAYOUTJSON: modelJson});
		}
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var unlockComponentAndObject = function(locks, componentName) {
		var promise = $q(function(resolve, reject) {
			if (angular.isUndefined(locks)) {
				reject(Error());
			}
			var unlockClassNames = [];
			var unlockIds = [];
			angular.forEach(locks, function(lockItem) {
				unlockClassNames.push(lockItem.className);
				unlockIds.push(lockItem.id);
			});
			if ((!unlockClassNames.length) || (!unlockIds.length)) {
				reject(Error());
			}
			var unlockUrl = (routerUrl + '?TUNLOCK=1');
			var requestParams = {
				TUNLOCKCLASSNAMES: unlockClassNames,
				TUNLOCKIDS: unlockIds
			};
			if (angular.isDefined(componentName)) {
				requestParams['TCOMPONENT'] = componentName;
			}
			
			$http.post(unlockUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var unlockAll = function() {
		var promise = $q(function(resolve, reject) {
			var unlockUrl = (routerUrl + '?TUNLOCK=1');
			var requestParams = {};
			
			$http.post(unlockUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};

	var fetchLookupData = function(pageNumber, classQueryName, params,
									brokerMethodName, componentContext, dynamicFavourites, componentItem, maxRows) {
		var promise = $q(function(resolve, reject) {
			if ((angular.isUndefined(pageNumber)) || (pageNumber == '') ||
				(angular.isUndefined(classQueryName)) || (classQueryName == '') ||
				(angular.isUndefined(params))) {
				reject(Error());
			}
			var requestParams = {
				TLOOKUP: classQueryName,
				TPAGCNT: pageNumber,
				TBROKERMETHODNAME: brokerMethodName,
				CONTEXT2: componentContext,
				TLOOKUPDYNAMICFAVOURITES: dynamicFavourites,
				TLOOKUPCOMPONENTITEM: componentItem
			};
			if (angular.isDefined(maxRows) && (maxRows > 0)) requestParams.TROWSPERPAGE = maxRows;
			angular.extend(requestParams, params);
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};

	var processEvent = function(requestParams) {
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var fetchDocumentMIMEType = function(documentUrl) {
		// Used to find the MIME type of the document at the given URL
		// (e.g "websys.Document.cls?ID=0rz7kP5bjBF7TjkqfemT9g--")
		var promise = $q(function(resolve, reject) {
			// Only make a HEAD request, so we don't bother with the response body
			$http.head(documentUrl)
			.then(function(data) {
				var headersObj = data.headers();
				var type = headersObj['content-type'];
				// Some content-types contain charsets info we don't care about (e.g "text/plain; charset=utf-8")
				if (type.indexOf(';') != -1) {
					type = type.split(';')[0];
				}
				resolve(type);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};

	// Fetch Document of type HTMLRichText (websys.Document)
	// docId is encrypted listbuild of document id i.e. $lb(docId)
	var fetchDocumentData = function(src) {
		var promise = $q(function(resolve, reject) {
			$http.post(src)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(Error(data));
			});
		});
		return promise;
	};
	
	var fetchFloorplanData = function(wardId, roomId, roomIndex, roomPatientIndex, pageCount, twkfl, twkfli, context) {
		var requestParams = {
			TFLOORPLAN: 1,
			TFLOORPLANWARDID: wardId,
			TFLOORPLANROOMID: roomId,
			TFLOORPLANROOMINDEX: roomIndex,
			TFLOORPLANROOMPATIENTINDEX: roomPatientIndex,
			TPAGCNT: pageCount,
			TFLOORPLANTWKFL: twkfl,
			TFLOORPLANTWKFLI: twkfli,
			TFLOORPLANCONTEXT: context
		};
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var fetchPWBData = function(params) {
		var requestParams = {
			TPWB: 1,
		};
		angular.extend(requestParams, params);
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	var fetchNotificationData = function(params) {
		var requestParams = {
			TNOTIFICATION: 1,
		};
		angular.extend(requestParams, params);
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};

	var fetchTimelineItemsData = function(timelineId, timeFrom, timeTo, interval, timeNow, params) {
		var requestParams = {
			TTIMELINEITEMS: 1,
			TTIMELINEID: timelineId,
			TTIMELINETIMEFROM: timeFrom,
			TTIMELINETIMETO: timeTo,
			TTIMELINEINTERVAL: interval,
			TTIMELINETIMENOW: timeNow
		};
		angular.extend(requestParams, params);
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams)
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;	
	};
	
	var fetchIconProfileData = function(iconProfileId, componentName, arrayNode, params) {
		if (angular.isUndefined(arrayNode)) arrayNode = 'ARY';
		var requestParams = {
			TICONPROFILE: iconProfileId,
			TCOMPONENT: componentName,
			TICONPROFILEARRAYNODE: arrayNode
		};
		angular.extend(requestParams, params);
		var promise = $q(function(resolve, reject) {
			$http.post(routerUrl, requestParams, {ignoreLoadingBar: true})
			.then(function(data) {
				resolve(data);
			}, function(data) {
				reject(data);
			});
		});
		return promise;
	};
	
	/**
	* @ngdoc method
	* @name urlToObject
	* @methodOf tcApp.SystemRouter
	* @description
	* return URL parameters list a=b&c=d as a JavaScript object {a:b,c:d}
	*/
	var urlToObject = function(url) {
		var name,value;
		if (angular.isUndefined(url) || (url === '')) return {};
		if (angular.isObject(url)) return url;
		
		var arr = url.split('&');
		var obj = {};
		for (var i = 0; i < arr.length; i++) {

			var equalsPos = arr[i].indexOf('=');
			if (equalsPos > -1) {
				name = arr[i].substring(0, equalsPos);
				value = arr[i].substring(equalsPos + 1);
			} else {
				name = arr[i];
				value = '';
			}
			if (name == '') continue;

			if (value.length > 0) {
				value = decodeURIComponent(value.replace(/\+/g, ' '));
			}
			if (angular.isArray(obj[name])) {
				obj[name].push(value);
			}
			if (angular.isString(obj[name])) {
				obj[name] = new Array(obj[name],value);
			}
			if (angular.isUndefined(obj[name])) {
				obj[name] = value;
			}
		}
		return obj;
	};

	/**
	* @ngdoc method
	* @name hasPendingRequests
	* @methodOf tcApp.SystemRouter
	* @description
	* Returns whether there are pending HTTP requests
	* 'skipIconProfiles' will skip http requests for icon profiles to prevent blocking events while icons are loading
	*/
	var hasPendingRequests = function(skipIconProfiles) {
		var pendingRequests = false;
		if (skipIconProfiles) {
			angular.forEach($http.pendingRequests, function(request) {
				if (pendingRequests) return;
				if ((angular.isDefined(request.data))
					&& (angular.isDefined(request.data['TICONPROFILE']))) return;
				
				pendingRequests = true;
			});
		} else {
			pendingRequests = ($http.pendingRequests.length > 0);
		}
		return pendingRequests;
	};
	
	var getTemplateUrl = function(componentName, context, isDisplayOnly, tuidArray) {
		var templateUrl = routerUrl;
		templateUrl += '?TLAYOUT=1&TCOMPONENT=' + componentName;
		if (angular.isDefined(context)) {
			templateUrl += '&CONTEXT=' + context;
		}
		if (isDisplayOnly) {
			templateUrl += '&tkDisplayOnly=1';
		}
		// Pass all parameters when retrieving layout template, so we can have conditional logic in GenLayout
		if (angular.isDefined(tuidArray)) {
			templateUrl += '&TUID=' + tuidArray[0] + '&TUID=' + tuidArray[1];
		}
		return templateUrl;
	};
			
	return {
		processWorkflow: processWorkflow,
		fetchSessionData: fetchSessionData,
		checkSession: checkSession,
		extendSession: extendSession,
		fetchComponentData: fetchComponentData,
		fetchChartData: fetchChartData,
		fetchChartHasData: fetchChartHasData,
		fetchChartItemData: fetchChartItemData,
		saveLayout: saveLayout,
		runMenuMethod: runMenuMethod,
		sourceControlAction: sourceControlAction,
		importLayout: importLayout,
		unlockComponentAndObject: unlockComponentAndObject,
		unlockAll: unlockAll,
		fetchLookupData: fetchLookupData,
		processEvent: processEvent,
		fetchDocumentMIMEType: fetchDocumentMIMEType,
		fetchDocumentData: fetchDocumentData,
		fetchFloorplanData: fetchFloorplanData,
		fetchPWBData: fetchPWBData,
		fetchNotificationData: fetchNotificationData,
		fetchLayoutTranslations: fetchLayoutTranslations,
		fetchTimelineItemsData: fetchTimelineItemsData,
		fetchIconProfileData: fetchIconProfileData,
		urlToObject: urlToObject,
		hasPendingRequests: hasPendingRequests,
		getTemplateUrl: getTemplateUrl
	};
});
